import {
  Badge,
  Card,
  Grid,
  Group,
  LoadingOverlay,
  Paper,
  Stack,
  Text
} from "@mantine/core";

const ReportCollector = ({ totales, totalTickets, loading = false }) => {

  const userTypes = [
    { label: "Cuadrillas", code: "cuadrilla", color: "blue" },
    { label: "Trabajadores", code: "trabajador", color: "green" },
    { label: "Estudiantes", code: "estudiante", color: "orange" },
    { label: "Proveedores", code: "proveedor", color: "purple" },
    { label: "Visitantes", code: "visitante", color: "cyan" },
    { label: "Guardias", code: "guardia", color: "orange" },
    { label: "Expatriados", code: "expatriado", color: "blue" },
    { label: "No identificados", code: undefined, color: "gray" },
  ];

  const renderSummaryTable = () => (
    <Grid gutter="xs">
      {userTypes.map(({ label, code, color }) => (
        <Grid.Col key={label} span={12}>
          <Paper
            shadow="xs"
            p="xs"
            sx={{
              background: "linear-gradient(45deg, #e0f3fc, #b3e0ff)",
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "scale(1.02)",
                boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
              },
            }}
          >
            <Grid>
              <Grid.Col
                span={8}
                style={{ alignItems: "center", display: "flex" }}
              >
                <Text size="sm" color="dark.6" fz={18} weight={500}>
                  <Badge color={color} variant="light">
                    <Text size="sm" fz={20} weight={500}>
                      {label}
                    </Text>
                  </Badge>
                </Text>
              </Grid.Col>
              <Grid.Col span={4} style={{ textAlign: "right" }}>
                <Text size="sm" color="dark.6" fz={30} weight={500}>
                  {totales[code] || 0}
                </Text>
              </Grid.Col>
            </Grid>
          </Paper>
        </Grid.Col>
      ))}
    </Grid>
  );

  if (loading) {
    return (
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <LoadingOverlay visible={true} overlayBlur={2} />
      </Card>
    );
  }

  return (
    <Card
      shadow="sm"
      padding="lg"
      radius="md"
      withBorder
      p="xs"
      sx={{
        background: "transparent",
        border: "none",
        boxShadow: "none",
        height: "100%",
        transition: "all 0.3s ease",
      }}
    >
      <Stack
        spacing="md"
        style={{
          height: "100%",
          background: "transparent",
        }}
      >
        <Group
          position="apart"
          mb="xs"
          sx={{
            "& > *": {
              background: "transparent !important",
            },
          }}
          style={{
            padding: "0px",
            margin: "0px",
            width: "100%",
          }}
        >
          <Badge
            color={"green"}
            variant="light"
            sx={{
              background: "rgba(0,0,0,0.05) !important",
              border: "1px solid rgba(0,0,0,0.1)",
            }}
            size="lg"
            style={{
              padding: "5px 10px",
              margin: "0px",
              width: "100%",
              textAlign: "center",
            }}
          >
            <Text fz={25}>{totalTickets} Tickets Confirmados</Text>
          </Badge>
        </Group>
        {renderSummaryTable()}
      </Stack>
    </Card>
  );
};

export default ReportCollector;
